import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import OnOffSwitch, {
  OnOffSwitchProps,
} from 'src/components/OnOffSwitch/OnOffSwitch'
import { css } from 'styled-components'

interface OnOffSwitchWithLabelProps extends OnOffSwitchProps {
  label?: React.ReactElement | string
  subLabel?: React.ReactElement | string
}

const OnOffSwitchWithLabel: React.FC<OnOffSwitchWithLabelProps> = ({
  label,
  subLabel,
  ...rest
}): React.ReactElement => {
  return (
    <label
      css={css`
        display: flex;
        justify-content: space-between;
        gap: 4px;
      `}
    >
      <div
        css={css`
          display: flex;
          flex-direction: column;
          gap: 8px;
          margin-top: 2px;
          flex: 1;
        `}
      >
        <span
          css={css`
            ${getFontCss(
              14,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.medium,
            )}
          `}
        >
          {label ?? '--'}
        </span>
        {subLabel && (
          <span
            css={css`
              ${getFontCss(
                12,
                styleConstants.colors.gray_darkest,
                styleConstants.fontFamilies.regular,
              )}
            `}
          >
            {subLabel}
          </span>
        )}
      </div>
      <OnOffSwitch
        css={css`
          flex: 1;
        `}
        {...rest}
        smallMode
      />
    </label>
  )
}

export default OnOffSwitchWithLabel
